import { htPdfDrawFullWidthRowFrame } from './htPdfFullWidthFrame';

const PAD = 1.2;
const EXCEL_PT_TO_MM = 25.4 / 72;
/** Misma altura visual que fila título modalidad (33). */
export const HT_SECTION_TITLE_ROW_MM = 15.6 * EXCEL_PT_TO_MM;

/** Título de sección: negrita, centrado (como MODALIDADE DE TRATAMENTO). */
export function drawHtSectionTitleRowPdf(doc, xs, y, excelRow, title) {
  const x0 = xs[0];
  const wFull = xs[5] - x0;
  const cx = x0 + wFull / 2;
  const h = HT_SECTION_TITLE_ROW_MM;

  htPdfDrawFullWidthRowFrame(doc, xs, y, h, excelRow, []);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7);
  doc.text(title, cx, y + h / 2, {
    align: 'center',
    baseline: 'middle',
    maxWidth: wFull - PAD * 2,
  });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6.2);
  return y + h;
}
